"use client";

import { useAuth } from "@/context/authcontext";

interface AssetNameTitleProps {
    displayName: string;
}

const AssetNameTitle = ({ displayName }: AssetNameTitleProps) => {
    const { isAuthenticated, isAuthFetched } = useAuth();

    // Default to H1 until client auth resolves — matches SSR output for crawlers and avoids hydration mismatch.
    if (!isAuthFetched || !isAuthenticated) {
        return <h1 className="text-4xl font-semibold sm:text-6xl">{displayName}</h1>;
    }

    return <h2 className="text-4xl font-semibold sm:text-6xl">{displayName}</h2>;
};

export default AssetNameTitle;
